import { SVGProps } from 'react';

const WarningSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    data-testid="container"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 163 163"
    {...props}
  >
    <g>
      <path
        fill="#E8E9F7"
        d="M142.065 127.355H20.935c-5.755 0-11.027-3.132-13.829-8.173a15.912 15.912 0 0 1 .382-16.066l54.529-87.177A22.953 22.953 0 0 1 81.5 5.092c7.947 0 15.307 4.1 19.484 10.847l54.528 87.203c3.031 4.888 3.209 11.05.408 16.066a15.886 15.886 0 0 1-13.855 8.147Z"
      />
      <path fill="#E8E9F7" d="M94.234 127.355H68.766V163h25.468v-35.645Z" />
      <path
        fill="#7364DB"
        d="M159.816 100.443 105.313 13.24A27.99 27.99 0 0 0 81.5 0a28.048 28.048 0 0 0-23.814 13.24L3.183 100.442a20.941 20.941 0 0 0-.51 21.209 20.97 20.97 0 0 0 18.262 10.795h42.737v25.461A5.075 5.075 0 0 0 68.765 163a5.075 5.075 0 0 0 5.094-5.092v-25.461H89.14v25.461A5.075 5.075 0 0 0 94.234 163a5.075 5.075 0 0 0 5.094-5.092v-25.461h42.736c7.616 0 14.619-4.125 18.287-10.77a20.93 20.93 0 0 0-.535-21.234Zm-17.828 21.82H20.935a10.776 10.776 0 0 1-9.398-5.525 10.772 10.772 0 0 1 .28-10.898l54.529-87.203c3.234-5.296 8.99-8.555 15.205-8.555a17.822 17.822 0 0 1 15.23 8.555l54.401 87.203a10.771 10.771 0 0 1 .28 10.898 10.776 10.776 0 0 1-9.398 5.525h-.076Z"
      />
      <path
        fill="#7364DB"
        d="M81.5 89.164a5.075 5.075 0 0 1-5.094-5.093V43.334a5.075 5.075 0 0 1 5.094-5.092 5.075 5.075 0 0 1 5.094 5.092v40.737a5.075 5.075 0 0 1-5.094 5.093Zm0 20.368a5.075 5.075 0 0 1-5.094-5.092 5.075 5.075 0 0 1 5.094-5.092 5.075 5.075 0 0 1 5.094 5.092 5.075 5.075 0 0 1-5.094 5.092Z"
      />
    </g>
  </svg>
);

export default WarningSvg;
